/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const spacerMargin = css({
  marginBottom: 32,
  marginTop: 40,
  [MediaQueries.mdAndUp]: {
    marginBottom: 56,
  },

  [MediaQueries.lgAndUp]: {
    marginTop: 64,
  },
});

export const spacerPadding = css({
  paddingTop: 40,
  paddingBottom: 24,
  [MediaQueries.mdAndUp]: {
    paddingTop: 48,
    paddingBottom: 50,
  },
});

export const heroTitle = css(typography.effra48, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  margin: 0,
});

export const aligner = css({
  marginTop: 32,
  position: 'relative',

  [MediaQueries.xl]: {
    alignItems: 'center',
  },
});
